import { Link } from 'react-router'
import { Plus } from 'lucide-react'
import { useNavigateWithReturnUrl } from '@klear/ui/wizard/return-url'
import type { ReactNode } from 'react'

export type CreateEntityReturnLinkProps = {
  to: string
  children?: ReactNode
  className?: string
}

export function CreateEntityReturnLink({
  to,
  children = (
    <>
      <Plus className="h-3 w-3 mr-1" />
      Create
    </>
  ),
  className = 'inline-flex h-auto items-center p-0 text-xs text-muted-foreground hover:text-foreground underline-offset-4 hover:underline'
}: CreateEntityReturnLinkProps) {
  const { href } = useNavigateWithReturnUrl()
  return (
    <Link to={href(to)} className={className}>
      {children}
    </Link>
  )
}
